import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mergeProps as $7CUUz$mergeProps, filterDOMProps as $7CUUz$filterDOMProps } from "@react-aria/utils";
import { useFocusable as $7CUUz$useFocusable } from "@react-aria/focus";
import { usePress as $7CUUz$usePress } from "@react-aria/interactions";
function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
  var _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    isRequired = props.isRequired,
    isReadOnly = props.isReadOnly,
    value = props.value,
    name = props.name,
    children = props.children,
    ariaLabel = props['aria-label'],
    ariaLabelledby = props['aria-labelledby'],
    _props$validationStat = props.validationState,
    validationState = _props$validationStat === void 0 ? 'valid' : _props$validationStat;
  var onChange = function onChange(e) {
    // since we spread props on label, onChange will end up there as well as in here.
    // so we have to stop propagation at the lowest level that we care about
    e.stopPropagation();
    state.setSelected(e.target.checked);
  };
  var hasChildren = children != null;
  var hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
  // This handles focusing the input on pointer down, which Safari does not do by default.
  var _$7CUUz$usePress = $7CUUz$usePress({
      isDisabled: isDisabled
    }),
    pressProps = _$7CUUz$usePress.pressProps;
  var _$7CUUz$useFocusable = $7CUUz$useFocusable(props, ref),
    focusableProps = _$7CUUz$useFocusable.focusableProps;
  var interactions = $7CUUz$mergeProps(pressProps, focusableProps);
  var domProps = $7CUUz$filterDOMProps(props, {
    labelable: true
  });
  return {
    inputProps: $7CUUz$mergeProps(domProps, _objectSpread({
      'aria-invalid': validationState === 'invalid' || undefined,
      'aria-errormessage': props['aria-errormessage'],
      'aria-controls': props['aria-controls'],
      'aria-readonly': isReadOnly || undefined,
      'aria-required': isRequired || undefined,
      onChange: onChange,
      disabled: isDisabled,
      value: value,
      name: name,
      type: 'checkbox'
    }, interactions))
  };
}
export { $d2c8e2b0480f3f34$export$cbe85ee05b554577 as useToggle };